<template>
  <tr class="table__row table__row--mobile-pad">
    <td class="table__cell--description">{{ transaction.description }}</td>
    <td class="table__cell--date">{{ transaction.date }}</td>
    <td class="table__cell--amount"><span :class="transactionClass">{{ transaction.amount }}</span></td>
    <td class="table__cell table__cell--action"></td>
  </tr>
</template>

<script>
  export default {
    name: 'FuelFundsTransaction',
    props: ['transaction'],
    computed: {
      transactionClass() {
        return `fuel-funds__transaction--${this.transaction.balance_sign}`;
      },
    },
  };
</script>

<style scoped>

</style>
